export enum ShippingType {
  None = 0,
  PBH = 1,
  RBH = 2,
}
